import { createSlice } from "@reduxjs/toolkit";

const emptyMetric = () => ({
  items: [],
  total: 0,
  page: 1,
  limit: 25,
  byType: {},
  loading: false,
});

const initialState = {
  criticalAlerts: emptyMetric(),
  overdueTasks: emptyMetric(),
  overdueNotes: emptyMetric(),
  pendingNotes: emptyMetric(),
  missingCarePlans: emptyMetric(),
  expiringDocuments: emptyMetric(),
  marCompletion: emptyMetric(),
  docCompletion: emptyMetric(),
};

export const skypointAlertsSlice = createSlice({
  name: "skypointAlerts",
  initialState,
  reducers: {
    setCriticalAlertsLoading(state, action) {
      state.criticalAlerts.loading = action.payload;
    },
    setCriticalAlerts(state, action) {
      const { items, total, page, limit, byType } = action.payload || {};
      state.criticalAlerts = {
        items: items || [],
        total: total || 0,
        page: page || 1,
        limit: limit || 25,
        byType: byType || {},
        loading: false,
      };
    },
    setOverdueTasksLoading(state, action) {
      state.overdueTasks.loading = action.payload;
    },
    setOverdueTasks(state, action) {
      const { items, total, page, limit } = action.payload || {};
      state.overdueTasks = {
        items: items || [],
        total: total || 0,
        page: page || 1,
        limit: limit || 25,
        byType: {},
        loading: false,
      };
    },
    // Generic per-tile setter — `key` selects which tile to populate.
    setTileLoading(state, action) {
      const { key, loading } = action.payload || {};
      if (key && state[key]) state[key].loading = !!loading;
    },
    setTileData(state, action) {
      const { key, data } = action.payload || {};
      if (!key || !state[key]) return;
      const { items, total, page, limit } = data || {};
      state[key] = {
        items: items || [],
        total: total || 0,
        page: page || 1,
        limit: limit || 25,
        byType: {},
        loading: false,
      };
    },
    resetSkypointAlerts() {
      return initialState;
    },
  },
});

export const {
  setCriticalAlertsLoading,
  setCriticalAlerts,
  setOverdueTasksLoading,
  setOverdueTasks,
  setTileLoading,
  setTileData,
  resetSkypointAlerts,
} = skypointAlertsSlice.actions;

export default skypointAlertsSlice.reducer;
